import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Layout from "../../components/Layout.js";
import axios from "axios";
import Select from "react-select";
import { apiFetch } from "../../api.js";

const AccountDetails = () => {
  const { unqid } = useParams();
  const navigate = useNavigate();
  const allowAlphabets = (value) => value.replace(/[^a-zA-Z ]/g, "");
  const allowNumbers = (value) => value.replace(/[^0-9]/g, "");
  const allowAlphaNumeric = (value) => value.replace(/[^a-zA-Z0-9 ]/g, "");
  const validateEmail = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  const validatePhone = (value) => /^[0-9+\-()\s]{7,15}$/.test(value);
  const validateMobile = (value) => /^[0-9]{10}$/.test(value);

  // Account fields
  const [m1_2, setM1_2] = useState("");
  const [title, setTitle] = useState("MR");
  const [accountHeadName, setAccountHeadName] = useState("");
  const [printName, setPrintName] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [country, setCountry] = useState("India");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [area, setArea] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [schedule, setSchedule] = useState("");
  const [prefix, setPrefix] = useState("");
  const [debitCredit, setDebitCredit] = useState("D");
  const [openingBalance, setOpeningBalance] = useState("");
  const [limit, setLimit] = useState("RECEIPT");
  const [statesList, setStatesList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);
  const [schedulesList, setSchedulesList] = useState([]);
  const [areasList, setAreasList] = useState([]);
  const [bankName, setBankName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [branchName, setBranchName] = useState("");
  const [branchCode, setBranchCode] = useState("");
  const [ifscCode, setIfscCode] = useState("");
  const [micrCode, setMicrCode] = useState("");
  const [cinno, setCINNo] = useState("");
  const [tanno, setTANNo] = useState("");
  const [pinno, setPINNO] = useState("");
  const [gstin, setGSTIN] = useState("");
  const [fax, setFAX] = useState("");
  const [aadharno, setAADHARNO] = useState("");
  const [contactperson1, setContactPerson1] = useState("");
  const [contactperson2, setContactPerson2] = useState("");
  const [contactperson3, setContactPerson3] = useState("");
  const [mobileno1, setMobileNo1] = useState("");
  const [mobileno2, setMobileNo2] = useState("");
  const [mobileno3, setMobileNo3] = useState("");
  const [phoneno1, setPhoneNo1] = useState("");
  const [phoneno2, setPhoneNo2] = useState("");
  const [phoneno3, setPhoneNo3] = useState("");
  const [email1, setEmail1] = useState("");
  const [email2, setEmail2] = useState("");
  const [email3, setEmail3] = useState("");
  const [dateofbirth, setDateOfBirth] = useState("");
  const [dateofanniversary, setDateOfAnniversary] = useState("");
  const [city1, setCity1] = useState("");
  const [sameAsPrev, setSameAsPrev] = useState(false);
  const [billingAddress, setBillingAddress] = useState("");
  const [showAccount, setShowAccount] = useState(true);
  const [showBank, setShowBank] = useState(false);
  const [showTax, setShowTax] = useState(false);
  const [showpersonaldetails, setPersonaDetails] = useState(false);
  const [ipAddress, setIpAddress] = useState("");
  const [userId, setUserId] = useState("");
  const [serverIp] = useState(window.location.hostname);
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const stateOptions = statesList.map((s) => ({
    value: s.value,
    label: s.value,
  }));
  const cityOptions = Array.isArray(citiesList)
    ? citiesList.map((c) => ({
        value: c.value,
        label: c.label,
      }))
    : [];
  const areaOptions = Array.isArray(areasList)
    ? areasList.map((a) => ({
        value: a.data,
        label: a.value,
      }))
    : [];
  const scheduleOptions = Array.isArray(schedulesList)
    ? schedulesList.map((s) => ({
        value: s.value,
        label: s.data,
      }))
    : [];

  const customStyles = {
    control: (base) => ({
      ...base,
      padding: "2px",
      borderRadius: "4px",
      borderColor: "#ccc",
      minHeight: "42px",
    }),
  };

  const fetchStates = async () => {
    try {
      const res = await apiFetch(
        "/api/accountmaster/states",
        {
          method: "POST",
        },
      );
      const data = await res.json();
      setStatesList(data);
    } catch (err) {
      console.error("Error fetching states:", err);
    }
  };

  const fetchCities = async (stateCode) => {
    if (!stateCode) return;
    try {
      const res = await apiFetch(
        "/api/accountmaster/cities",
        {
          method: "POST",
          body: JSON.stringify({ state: stateCode }),
        },
      );
      const data = await res.json();
      setCitiesList(data);
    } catch (err) {
      console.error("❌ Error fetching cities:", err);
    }
  };

  const fetchSchedules = async () => {
    try {
      const res = await apiFetch(
        "/api/accountmaster/schedules",
        {
          method: "POST",
        },
      );
      const data = await res.json();
      setSchedulesList(data);
    } catch (err) {
      console.error("Error fetching schedules:", err);
    }
  };
  useEffect(() => {
    apiFetch("/api/get-ip")
      .then((res) => setIpAddress(res.data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);

  useEffect(() => {
    const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};
    setUserId(storedUserInfo.userId || "");
  }, []);

  useEffect(() => {
    const fetchAreasByCity = async (cityName) => {
      if (!cityName) return setAreasList([]);
      const backendURL = "";
      const endpoint = `${backendURL}/api/accountmaster/areas-by-city`;

      try {
        const res = await apiFetch(
          `${endpoint}?city=${encodeURIComponent(cityName)}`,
        );

        if (res.status === 404) {
          console.warn(`⚠️ Endpoint not found: ${endpoint}`);
          setAreasList([]);
          return;
        }

        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);

        const data = await res.json();
        setAreasList(data);
        setArea("");
      } catch (err) {
        console.error("❌ Error fetching areas by city:", err);
        setAreasList([]);
      }
    };

    if (city) fetchAreasByCity(city);
    else setAreasList([]);
  }, [city]);

  const handleSave = async () => {
    try {
      const payload = {
        what: "insert",
        m1_1: "",
        m1_2: "",
        userId,
        ipAddress,
        serverIp,
        accountHeadName: accountHeadName,
        printName: printName,
        debitCredit: debitCredit,
        schedule: schedule,
        address1: address1,
        address2: address2,
        city: city,
        state: state,
        country: country,
        zipCode: zipCode,
        contactperson1: contactperson1,
        contactperson2: contactperson2,
        contactperson3: contactperson3,
        mobileno1: mobileno1,
        mobileno2: mobileno2,
        mobileno3: mobileno3,
        phoneno1: phoneno1,
        phoneno2: phoneno2,
        phoneno3: phoneno3,
        email1: email1,
        email2: email2,
        email3: email3,
        fax: fax,
        sameAsPrev: sameAsPrev,
        billingAddress: billingAddress,
        city1: city1,
        limit: limit,
        dateofbirth: dateofbirth,
        dateofanniversary: dateofanniversary,
        gstin: gstin,
        cinno: cinno,
        tanno: tanno,
        pinno: pinno,
        bankName: bankName,
        accountNumber: accountNumber,
        branchName: branchName,
        branchCode: branchCode,
        ifscCode: ifscCode,
        micrCode: micrCode,
        mobile: mobile,
        email: email,
        aadharno: aadharno,
        title: title,
        openingBalance:
          openingBalance !== undefined &&
          openingBalance !== null &&
          openingBalance !== ""
            ? openingBalance
            : "0",
        prefix: prefix,
        area: area,
      };
      const res = await apiFetch(
        "/api/accountmaster",
        {
          method: "POST",

          body: JSON.stringify(payload),
        },
      );
      const data = await res.json();
      if (data.success) {
        alert("Saved successfully!");
        navigate("/accounts/grid");
      } else {
        alert("Error: " + data.message);
      }
    } catch (err) {
      console.error("Save error:", err);
      alert("Server error");
    }
  };

  const handleUpdate = async () => {
    try {
      const payload = {
        what: "update",
        m1_1: "",
        m1_2: m1_2,
        accountHeadName: accountHeadName,
        printName: printName,
        debitCredit: debitCredit,
        schedule: schedule,
        address1: address1,
        address2: address2,
        city: city,
        state: state,
        country: country,
        zipCode: zipCode,
        contactperson1: contactperson1,
        contactperson2: contactperson2,
        contactperson3: contactperson3,
        mobileno1: mobileno1,
        mobileno2: mobileno2,
        mobileno3: mobileno3,
        phoneno1: phoneno1,
        phoneno2: phoneno2,
        phoneno3: phoneno3,
        email1: email1,
        email2: email2,
        email3: email3,
        fax: fax,
        sameAsPrev: sameAsPrev,
        billingAddress: billingAddress,
        city1: city1,
        limit: limit,
        dateofbirth: dateofbirth,
        dateofanniversary: dateofanniversary,
        gstin: gstin,
        cinno: cinno,
        tanno: tanno,
        pinno: pinno,
        bankName: bankName,
        accountNumber: accountNumber,
        branchName: branchName,
        branchCode: branchCode,
        ifscCode: ifscCode,
        micrCode: micrCode,
        mobile: mobile,
        email: email,
        aadharno: aadharno,
        title: title,
        openingBalance:
          openingBalance !== undefined &&
          openingBalance !== null &&
          openingBalance !== ""
            ? openingBalance
            : "0",
        prefix: prefix,
        area: area,
      };

      const res = await apiFetch(
        "/api/accountmaster/update",
        {
          method: "POST",

          body: JSON.stringify(payload),
        },
      );
      const data = await res.json();
      if (data.success) {
        alert("Update successfully!");
        navigate("/accounts/grid");
      } else {
        alert("Error: " + data.message);
      }
    } catch (err) {
      console.error("Save error:", err);
      alert("Server error");
    }
  };

  const handleExit = () => {
    navigate("/accounts/grid");
  };
  const location = useLocation();
  const editData = location.state?.editData || null;
  console.log(editData);
  useEffect(() => {
    if (!editData) return;
    setM1_2(editData.m1_2 || "");
    setAccountHeadName(editData.m1_7 || "");
    setPrintName(editData.m1_8 || "");
    setDebitCredit(editData.m1_9 || "D");
    setSchedulesList(editData.m1_10 || "");
    setAddress1(editData.m1_11 || "");
    setAddress2(editData.m1_12 || "");
    setCity(editData.m1_13 || "");
    setState(editData.m1_14 || "");
    setCountry(editData.m1_15 || "India");
    setZipCode(editData.m1_16 || "");
    setContactPerson1(editData.m1_17 || "");
    setContactPerson2(editData.m1_18 || "");
    setContactPerson3(editData.m1_19 || "");
    setMobileNo1(editData.m1_20 || "");
    setMobileNo2(editData.m1_21 || "");
    setMobileNo3(editData.m1_22 || "");
    setPhoneNo1(editData.m1_23 || "");
    setPhoneNo2(editData.m1_24 || "");
    setPhoneNo3(editData.m1_25 || "");
    setEmail1(editData.m1_26 || "");
    setEmail2(editData.m1_27 || "");
    setEmail3(editData.m1_28 || "");
    setFAX(editData.m1_29 || "");
    setSameAsPrev(editData.m1_30 === "Y");
    setBillingAddress(editData.m1_31 === "Y" ? editData.m1_31 : "");
    setCity(editData.m1_33 || "");
    setLimit(editData.m1_34 || "RECEIPT");
    setDateOfBirth(editData.m1_35 || "");
    setDateOfAnniversary(editData.m1_36 || "");
    setGSTIN(editData.m1_37 || "");
    setCINNo(editData.m1_38 || "");
    setTANNo(editData.m1_39 || "");
    setPINNO(editData.m1_40 || "");
    setBankName(editData.m1_41 || "");
    setAccountNumber(editData.m1_42 || "");
    setBranchName(editData.m1_43 || "");
    setBranchCode(editData.m1_44 || "");
    setIfscCode(editData.m1_45 || "");
    setMicrCode(editData.m1_46 || "");
    setMobile(editData.m1_47 || "");
    setAADHARNO(editData.m1_48 || "");
    setSchedule(editData.m1_49 || "");
    setTitle(editData.m1_51 || "MR");
    setOpeningBalance(editData.m1_52 || "");
    setPrefix(editData.m1_53 || "");
    setArea(editData.m1_54 || "");
    setEmail(editData.m1_55 || "");
    console.log(editData);
  }, [editData]);
  useEffect(() => {
    if (editData) {
      setSchedule(editData.m1_10 || "");
    }
  }, [editData]);

  useEffect(() => {
    if (editData && Array.isArray(schedulesList) && schedulesList.length > 0) {
      const match = schedulesList.find(
        (sch) =>
          sch.data.trim().toLowerCase() ===
          (editData.m1_10 || "").trim().toLowerCase(),
      );
      if (match) setSchedule(match.data);
    }
  }, [schedulesList, editData]);

  useEffect(() => {
    if (editData) {
      setState(editData.m1_14 || "");
    }
  }, [editData]);
  useEffect(() => {
    if (!editData) return;
    if (!Array.isArray(areasList) || areasList.length === 0) return;

    const match = areasList.find(
      (a) =>
        a.data?.trim().toUpperCase() ===
        (editData.m1_54 || "").trim().toUpperCase(),
    );

    if (match) {
      setArea(match.data); // ✅ THIS SELECTS AREA
    }
  }, [areasList, editData]);

  useEffect(() => {
    if (editData && citiesList.length > 0) {
      const match = citiesList.find(
        (c) =>
          c.label.toLowerCase() === (editData.m1_13 || "").toLowerCase() ||
          c.value === editData.m1_13,
      );
      if (match) setCity(match.value);
    }
  }, [citiesList, editData]);

  useEffect(() => {
    fetchStates();
    fetchSchedules();
  }, []);

  useEffect(() => {
    if (state) fetchCities(state);
    else setCitiesList([]);
  }, [state]);
  useEffect(() => {
    if (editData) {
      setArea(editData.m1_54 || "");
    }
  }, [editData]);
  useEffect(() => {
    if (sameAsPrev) {
      setBillingAddress(address1);
    } else {
      setBillingAddress("");
    }
  }, [sameAsPrev, address1, city]);

  /*------------------- Styles--------------*/
  const pageContainerStyle = {
    width: "100%",
    minHeight: "100%",
    backgroundColor: "#f4f6f8",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "10px",
    boxSizing: "border-box",
  };

  const containerStyle = {
    width: "100%",
    maxWidth: "1400px",
    padding: "16px",
    borderRadius: "8px",
    backgroundColor: "#fff",
    boxSizing: "border-box",
  };

  const headerStyle = {
    border: "2px solid #8B1E3F",
    borderRadius: "6px",
    padding: "15px",
    marginBottom: "20px",
    textAlign: "center",
    background: "#8B1E3F",
    fontWeight: "bold",
    fontSize: "1.5rem",
    color: "#fff",
  };

  const sectionHeaderStyle = {
    backgroundColor: "#f8bcbc",
    color: "#000",
    padding: "12px 15px",
    cursor: "pointer",
    fontWeight: "bold",
    marginTop: "15px",
    borderRadius: "4px",
  };

  const rowStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
    gap: "16px",
    marginBottom: "16px",
    width: "100%",
  };

  const columnStyle = {
    display: "flex",
    flexDirection: "column",
  };

  const inputStyle = {
    padding: "10px",
    marginTop: "5px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    width: "100%",
    boxSizing: "border-box",
  };

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "14px",
    flexWrap: "nowrap", // 🔥 no wrapping (forces one row)
    width: "100%",
    marginTop: "30px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px",
    height: "44px",
    padding: "0 18px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    whiteSpace: "nowrap",
  });
  const labelStyle = {
    fontWeight: "bold",
    marginBottom: "5px",
  };

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div style={headerStyle}>Account Master</div>

          {/* Account Section */}
          <div
            style={sectionHeaderStyle}
            onClick={() => setShowAccount(!showAccount)}
          >
            📂 Account Details
          </div>
          {showAccount && (
            <div style={{ padding: "15px", border: "1px solid #ccc" }}>
              <div style={rowStyle}>
                <div style={columnStyle}>
                  <label style={labelStyle}>Title</label>
                  <select
                    value={title}
                    onChange={(e) =>
                      setAccountHeadName(allowAlphabets(e.target.value))
                    }
                    style={inputStyle}
                  >
                    <option value="MR">MR</option>
                    <option value="MRS">MRS</option>
                    <option value="MISS">MISS</option>
                    <option value="M/S">M/S</option>
                    <option value="DR.">DR.</option>
                  </select>
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Account Head Name</label>
                  <input
                    type="text"
                    value={accountHeadName}
                    onChange={(e) =>
                      setAccountHeadName(allowAlphabets(e.target.value))
                    }
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Print Name</label>
                  <input
                    type="text"
                    value={printName}
                    onChange={(e) =>
                      setPrintName(allowAlphabets(e.target.value))
                    }
                    style={inputStyle}
                  />
                </div>
              </div>
              <div style={rowStyle}>
                <div style={columnStyle}>
                  <label style={labelStyle}>Address 1</label>
                  <textarea
                    value={address1}
                    onChange={(e) =>
                      setAddress1(allowAlphaNumeric(e.target.value))
                    }
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Address 2</label>
                  <textarea
                    value={address2}
                    onChange={(e) =>
                      setAddress2(allowAlphaNumeric(e.target.value))
                    }
                    style={inputStyle}
                  />
                </div>
              </div>
              <div style={rowStyle}>
                <div style={columnStyle}>
                  <label style={labelStyle}>Country</label>
                  <input
                    type="text"
                    value={country}
                    onChange={(e) => setCountry(allowAlphabets(e.target.value))}
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>State</label>
                  <Select
                    options={stateOptions}
                    value={stateOptions.find((o) => o.value === state) || null}
                    onChange={(selected) => setState(selected?.value)}
                    styles={customStyles}
                    placeholder="Select State"
                    isSearchable
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>City</label>

                  <Select
                    options={cityOptions}
                    value={cityOptions.find((o) => o.value === city) || null}
                    onChange={(selected) => setCity(selected?.value)}
                    styles={customStyles}
                    placeholder={state ? "Select City" : "Select State First"}
                    isSearchable
                    isDisabled={!state}
                  />
                </div>
              </div>
              <div style={rowStyle}>
                <div style={columnStyle}>
                  <label style={labelStyle}>Area</label>

                  <Select
                    options={areaOptions}
                    value={areaOptions.find((o) => o.value === area) || null}
                    onChange={(selected) => setArea(selected?.value)}
                    styles={customStyles}
                    placeholder={city ? "Select Area" : "Select City First"}
                    isSearchable
                    isDisabled={!city}
                  />
                </div>

                <div style={columnStyle}>
                  <label style={labelStyle}>Zip Code</label>
                  <input
                    type="text"
                    value={zipCode}
                    onChange={(e) => setZipCode(allowNumbers(e.target.value))}
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Mobile</label>
                  <input
                    type="text"
                    value={mobile}
                    onChange={(e) => setMobile(allowNumbers(e.target.value))}
                    onBlur={() => {
                      if (mobile && !validateMobile(mobile)) {
                        alert("Mobile number must be exactly 10 digits");
                      }
                    }}
                    style={inputStyle}
                  />
                </div>
              </div>
              <div style={rowStyle}>
                <div style={columnStyle}>
                  <label style={labelStyle}>Email</label>
                  <input
                    type="text"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onBlur={() => {
                      if (email && !validateEmail(email)) {
                        alert("Invalid Email Address");
                      }
                    }}
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Schedule</label>

                  <Select
                    options={scheduleOptions}
                    value={
                      scheduleOptions.find((o) => o.value === schedule) || null
                    }
                    onChange={(selected) => setSchedule(selected?.value)}
                    styles={customStyles}
                    placeholder="Select Schedule"
                    isSearchable
                  />
                </div>

                <div style={columnStyle}>
                  <label style={labelStyle}>Prefix</label>
                  <input
                    type="text"
                    value={prefix}
                    onChange={(e) => setPrefix(e.target.value)}
                    style={inputStyle}
                  />
                </div>
              </div>
              <div style={rowStyle}>
                <div style={columnStyle}>
                  <label style={labelStyle}>Debit/Credit</label>
                  <div>
                    <label style={{ fontWeight: "bold", marginRight: "15px" }}>
                      <input
                        type="radio"
                        value="D"
                        checked={debitCredit === "D"}
                        onChange={(e) => setDebitCredit(e.target.value)}
                      />
                      Debit
                    </label>
                    <label style={{ fontWeight: "bold" }}>
                      <input
                        type="radio"
                        value="C"
                        checked={debitCredit === "C"}
                        onChange={(e) => setDebitCredit(e.target.value)}
                      />
                      Credit
                    </label>
                  </div>
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Opening Balance</label>
                  <input
                    type="text"
                    value={openingBalance}
                    onChange={(e) =>
                      setOpeningBalance(allowNumbers(e.target.value))
                    }
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Limit on Receipts/Payments</label>
                  <div>
                    <label style={{ fontWeight: "bold", marginRight: "15px" }}>
                      <input
                        type="radio"
                        value="RECEIPT"
                        checked={limit === "RECEIPT"}
                        onChange={(e) => setLimit(e.target.value)}
                      />
                      RECEIPT
                    </label>
                    <label style={{ fontWeight: "bold" }}>
                      <input
                        type="radio"
                        value="PAYMENT"
                        checked={limit === "PAYMENT"}
                        onChange={(e) => setLimit(e.target.value)}
                      />
                      PAYMENT
                    </label>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Bank Section */}
          <div
            style={sectionHeaderStyle}
            onClick={() => setShowBank(!showBank)}
          >
            🏦 Bank Details
          </div>
          {showBank && (
            <div style={{ padding: "15px", border: "1px solid #ccc" }}>
              <div style={rowStyle}>
                <div style={columnStyle}>
                  <label style={labelStyle}>Bank Name</label>
                  <input
                    type="text"
                    value={bankName}
                    onChange={(e) =>
                      setBankName(allowAlphabets(e.target.value))
                    }
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Account Number</label>
                  <input
                    type="text"
                    value={accountNumber}
                    onChange={(e) =>
                      setAccountNumber(allowAlphaNumeric(e.target.value))
                    }
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Branch Name</label>
                  <input
                    type="text"
                    value={branchName}
                    onChange={(e) =>
                      setBranchName(allowAlphaNumeric(e.target.value))
                    }
                    style={inputStyle}
                  />
                </div>
              </div>
              <div style={rowStyle}>
                <div style={columnStyle}>
                  <label style={labelStyle}>Branch Code</label>
                  <input
                    type="text"
                    value={branchCode}
                    onChange={(e) =>
                      setBranchCode(allowAlphaNumeric(e.target.value))
                    }
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>IFSC Code</label>
                  <input
                    type="text"
                    value={ifscCode}
                    onChange={(e) => setIfscCode(allowNumbers(e.target.value))}
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>MICR Code</label>
                  <input
                    type="text"
                    value={micrCode}
                    onChange={(e) => setMicrCode(allowNumbers(e.target.value))}
                    style={inputStyle}
                  />
                </div>
              </div>
            </div>
          )}

          {/* Tax Section */}
          <div style={sectionHeaderStyle} onClick={() => setShowTax(!showTax)}>
            🧾 Tax Details
          </div>
          {showTax && (
            <div style={{ padding: "15px", border: "1px solid #ccc" }}>
              <div style={rowStyle}>
                <div style={columnStyle}>
                  <label style={labelStyle}>CIN Number</label>
                  <input
                    type="text"
                    value={cinno}
                    onChange={(e) =>
                      setCINNo(allowAlphaNumeric(e.target.value))
                    }
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>TAN Number</label>
                  <input
                    type="text"
                    value={tanno}
                    onChange={(e) =>
                      setTANNo(allowAlphaNumeric(e.target.value))
                    }
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Pin Number</label>
                  <input
                    type="text"
                    value={pinno}
                    onChange={(e) => setPINNO(allowNumbers(e.target.value))}
                    style={inputStyle}
                  />
                </div>
              </div>
              <div style={rowStyle}>
                <div style={columnStyle}>
                  <label style={labelStyle}>GSTIN</label>
                  <input
                    type="text"
                    value={gstin}
                    onChange={(e) =>
                      setGSTIN(allowAlphaNumeric(e.target.value))
                    }
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Fax</label>
                  <input
                    type="text"
                    value={fax}
                    onChange={(e) => setFAX(allowAlphaNumeric(e.target.value))}
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Aadhar Number</label>
                  <input
                    type="text"
                    value={aadharno}
                    onChange={(e) =>
                      setAADHARNO(allowAlphaNumeric(e.target.value))
                    }
                    style={inputStyle}
                  />
                </div>
              </div>
            </div>
          )}

          {/* Personal Detail Section */}
          <div
            style={sectionHeaderStyle}
            onClick={() => setPersonaDetails(!showpersonaldetails)}
          >
            👤 Personal Details
          </div>
          {showpersonaldetails && (
            <div style={{ padding: "15px", border: "1px solid #ccc" }}>
              <div style={rowStyle}>
                <div style={columnStyle}>
                  <label style={labelStyle}>Contact Person 1</label>
                  <input
                    type="text"
                    value={contactperson1}
                    onChange={(e) =>
                      setContactPerson1(allowAlphabets(e.target.value))
                    }
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Contact Person 2</label>
                  <input
                    type="text"
                    value={contactperson2}
                    onChange={(e) =>
                      setContactPerson2(allowAlphabets(e.target.value))
                    }
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Contact Person 3</label>
                  <input
                    type="text"
                    value={contactperson3}
                    onChange={(e) =>
                      setContactPerson3(allowAlphabets(e.target.value))
                    }
                    style={inputStyle}
                  />
                </div>
              </div>
              <div style={rowStyle}>
                <div style={columnStyle}>
                  <label style={labelStyle}>Mobile No 1</label>
                  <input
                    type="text"
                    value={mobileno1}
                    onChange={(e) => setMobileNo1(allowNumbers(e.target.value))}
                    onBlur={() => {
                      if (mobileno1 && !validateMobile(mobileno1)) {
                        alert("Mobile number must be exactly 10 digits");
                      }
                    }}
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Mobile No 2</label>
                  <input
                    type="text"
                    value={mobileno2}
                    onChange={(e) => setMobileNo2(allowNumbers(e.target.value))}
                    onBlur={() => {
                      if (mobileno2 && !validateMobile(mobileno2)) {
                        alert("Mobile number must be exactly 10 digits");
                      }
                    }}
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Mobile No 3</label>
                  <input
                    type="text"
                    value={mobileno3}
                    onChange={(e) => setMobileNo3(allowNumbers(e.target.value))}
                    onBlur={() => {
                      if (mobileno3 && !validateMobile(mobileno3)) {
                        alert("Mobile number must be exactly 10 digits");
                      }
                    }}
                    style={inputStyle}
                  />
                </div>
              </div>
              <div style={rowStyle}>
                <div style={columnStyle}>
                  <label style={labelStyle}>Phone No 1</label>
                  <input
                    type="text"
                    value={phoneno1}
                    onChange={(e) => setPhoneNo1(allowNumbers(e.target.value))}
                    onBlur={() => {
                      if (phoneno1 && !validatePhone(phoneno1)) {
                        alert("Invalid Phone Number");
                      }
                    }}
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Phone No 2</label>
                  <input
                    type="text"
                    value={phoneno2}
                    onChange={(e) => setPhoneNo2(allowNumbers(e.target.value))}
                    onBlur={() => {
                      if (phoneno2 && !validatePhone(phoneno2)) {
                        alert("Invalid Phone Number");
                      }
                    }}
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Phone No 3</label>
                  <input
                    type="text"
                    value={phoneno3}
                    onChange={(e) => setPhoneNo3(allowNumbers(e.target.value))}
                    onBlur={() => {
                      if (phoneno3 && !validatePhone(phoneno3)) {
                        alert("Invalid Phone Number");
                      }
                    }}
                    style={inputStyle}
                  />
                </div>
              </div>
              <div style={rowStyle}>
                <div style={columnStyle}>
                  <label style={labelStyle}>Email 1</label>
                  <input
                    type="text"
                    value={email1}
                    onChange={(e) => setEmail1(e.target.value)}
                    onBlur={() => {
                      if (email1 && !validateEmail(email1)) {
                        alert("Invalid Email Address");
                      }
                    }}
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Email 2</label>
                  <input
                    type="text"
                    value={email2}
                    onChange={(e) => setEmail2(e.target.value)}
                    onBlur={() => {
                      if (email2 && !validateEmail(email2)) {
                        alert("Invalid Email Address");
                      }
                    }}
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Email 3</label>
                  <input
                    type="text"
                    value={email3}
                    onChange={(e) => setEmail3(e.target.value)}
                    onBlur={() => {
                      if (email3 && !validateEmail(email3)) {
                        alert("Invalid Email Address");
                      }
                    }}
                    style={inputStyle}
                  />
                </div>
              </div>
              <div style={rowStyle}>
                <div style={columnStyle}>
                  <label style={labelStyle}>Date of Birth</label>
                  <input
                    type="date"
                    value={dateofbirth}
                    onChange={(e) => setDateOfBirth(e.target.value)}
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Date of Anniversary</label>
                  <input
                    type="date"
                    value={dateofanniversary}
                    onChange={(e) => setDateOfAnniversary(e.target.value)}
                    style={inputStyle}
                  />
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>City</label>
                  <input
                    type="text"
                    value={city1}
                    onChange={(e) => setCity1(e.target.value)}
                    style={inputStyle}
                  />
                </div>
              </div>
              <div style={rowStyle}>
                <div style={columnStyle}>
                  <label>
                    <input
                      type="checkbox"
                      checked={sameAsPrev}
                      onChange={() => setSameAsPrev(!sameAsPrev)}
                    />
                    Same As Previous Address
                  </label>
                </div>
                <div style={columnStyle}>
                  <label style={labelStyle}>Billing Address</label>
                  <textarea
                    value={billingAddress}
                    onChange={(e) => setBillingAddress(e.target.value)}
                    style={inputStyle}
                  />
                </div>
              </div>
            </div>
          )}

          {/* Action Buttons */}
          <div style={buttonContainerStyle}>
            {!editData && (
              <button style={buttonStyle("#4caf50")} onClick={handleSave}>
                Save
              </button>
            )}
            {editData && (
              <button style={buttonStyle("#2e20abff")} onClick={handleUpdate}>
                Update
              </button>
            )}
            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default AccountDetails;
